export function PropostaPublicaHero() {
  return (
    <section className="rounded-2xl border border-black/[0.06] bg-white p-6 sm:p-10 shadow-[0_12px_40px_rgba(12,13,14,0.06)]">
      <div className="max-w-2xl">
        <h1 className="text-3xl sm:text-5xl font-bold text-[#0c0d0e] tracking-tight leading-[1.05]">
          Rocket Search
        </h1>
        <p className="mt-4 text-base text-[#52525b] max-w-xl leading-relaxed">
          Revise o escopo, as condições de investimento e a validade antes de seguir para o aceite.
        </p>
      </div>
    </section>
  )
}
